import * as tslib_1 from "tslib";
import { QueryStringParamService } from './query-string-param-service';
import * as i0 from "@angular/core";
import * as i1 from "./query-string-param-service";
var DeepLinkProcessor = /** @class */ (function () {
    function DeepLinkProcessor(queryStringParamService) {
        this.queryStringParamService = queryStringParamService;
        this.identifyHandlers = [];
        this.isEmpty = function (obj) { return [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length; };
    }
    /**
     * Allows external code to intercept and handle querystring parameters
     * @param parameters - an object with a list of desired parameters. ex: {'whatYouWantItCalled': ['couldBeThis','orThis'], 'param2': 'param2'}
     * @param callback - callback
     * @param requireAll - if true, your handler will only be called if all of the specified parameters are available. Defaults to false
     * @return a function that can be called to unregister
     */
    DeepLinkProcessor.prototype.registerHandler = function (parameters, callback, requireAll) {
        var _this = this;
        if (requireAll === void 0) { requireAll = false; }
        var handler = {
            callback: callback,
            parameters: parameters,
            requireAll: requireAll
        };
        this.identifyHandlers.push(handler);
        //a function that will unregister this handler
        return function () {
            var index = _this.identifyHandlers.indexOf(handler);
            if (index > -1) {
                _this.identifyHandlers.splice(index, 1);
            }
        };
    };
    /**
     * Call all handlers in order until all parameters are processed or all handlers have been called.
     * If previous handlers have already processed all of the parameters in your request list (or if you speicifed requireAll, then if any of your paremeters were missing), your handler will not be called.
     * This should only be called once per page-load.
     */
    DeepLinkProcessor.prototype.process = function (search) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, queryParams, _c, _d, handler, handlerParameters, shouldCallHandler, paramNames, paramNames_1, paramNames_1_1, paramName, shouldDeleteParams, e_1_1;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        queryParams = this.queryStringParamService.getQueryStringParams(search);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, 7, 8]);
                        _c = tslib_1.__values(this.identifyHandlers), _d = _c.next();
                        _e.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 5];
                        handler = _d.value;
                        //if there are no more query parameters to process, stop here
                        if (this.isEmpty(queryParams)) {
                            return [3 /*break*/, 5];
                        }
                        handlerParameters = this.getParameters(handler.parameters, queryParams);
                        if (!(Object.keys(handlerParameters.parameters).length > 0)) return [3 /*break*/, 4];
                        shouldCallHandler = true;
                        //if the handler requires that all parameters be present, verify that is true
                        if (handler.requireAll) {
                            paramNames = Object.keys(handler.parameters);
                            try {
                                inner: for (paramNames_1 = tslib_1.__values(paramNames), paramNames_1_1 = paramNames_1.next(); !paramNames_1_1.done; paramNames_1_1 = paramNames_1.next()) {
                                    paramName = paramNames_1_1.value;
                                    if (handlerParameters.parameters[paramName] === undefined) {
                                        shouldCallHandler = false;
                                        break inner;
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (paramNames_1_1 && !paramNames_1_1.done && (_b = paramNames_1.return)) _b.call(paramNames_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        if (!shouldCallHandler) return [3 /*break*/, 4];
                        return [4 /*yield*/, handler.callback(handlerParameters.parameters)];
                    case 3:
                        shouldDeleteParams = _e.sent();
                        //if the callback explicitly returned anything other than false,
                        //then remove those params, since only one handler gets to process a given param
                        if (shouldDeleteParams !== false) {
                            this.removeParams(handlerParameters.parameterNames, queryParams);
                        }
                        _e.label = 4;
                    case 4:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    DeepLinkProcessor.prototype.getParameters = function (parameters, queryParams) {
        var e_3, _a;
        var handlerParameters = { parameters: {}, parameterNames: [] };
        try {
            for (var _b = tslib_1.__values(Object.keys(parameters)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                //if the param names is a string, convert it to an array. otherwise it's already in the proper format
                var paramNames = (Array.isArray(parameters[key]) ? parameters[key] : [parameters[key]]);
                handlerParameters.parameterNames.push.apply(handlerParameters.parameterNames, paramNames);
                var value = this.getAnyParam(paramNames, queryParams);
                if (value !== undefined) {
                    handlerParameters.parameters[key] = value;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return handlerParameters;
    };
    /**
     * Remove all parameters with the specified names
     */
    DeepLinkProcessor.prototype.removeParams = function (paramNames, queryParams) {
        var e_4, _a;
        try {
            for (var paramNames_2 = tslib_1.__values(paramNames), paramNames_2_1 = paramNames_2.next(); !paramNames_2_1.done; paramNames_2_1 = paramNames_2.next()) {
                var paramName = paramNames_2_1.value;
                paramName = (paramName + '').toLowerCase();
                if (queryParams[paramName]) {
                    queryParams[paramName] = null;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (paramNames_2_1 && !paramNames_2_1.done && (_a = paramNames_2.return)) _a.call(paramNames_2);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    /**
     * Given a list of param names, find the first defined value
     */
    DeepLinkProcessor.prototype.getAnyParam = function (paramNames, queryParams) {
        var e_5, _a;
        try {
            for (var paramNames_3 = tslib_1.__values(paramNames), paramNames_3_1 = paramNames_3.next(); !paramNames_3_1.done; paramNames_3_1 = paramNames_3.next()) {
                var paramName = paramNames_3_1.value;
                paramName = (paramName + '').toLowerCase();
                if (queryParams[paramName] !== undefined) {
                    return queryParams[paramName];
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (paramNames_3_1 && !paramNames_3_1.done && (_a = paramNames_3.return)) _a.call(paramNames_3);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    DeepLinkProcessor.ngInjectableDef = i0.defineInjectable({ factory: function DeepLinkProcessor_Factory() { return new DeepLinkProcessor(i0.inject(i1.QueryStringParamService)); }, token: DeepLinkProcessor, providedIn: "root" });
    return DeepLinkProcessor;
}());
export { DeepLinkProcessor };
